export enum IncomeStatementVisualizationTypes {
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY'
}